{
	"failedSwitchTitle": "Failed to Switch AI Style",
	"switchingAiStyle": "Switching AI Style...",
	"tryAgainLater": "Please try again later."
}
